import { render, staticRenderFns } from "./InviteButtons.vue?vue&type=template&id=5614b3ea&scoped=true"
var script = {}
import style0 from "./InviteButtons.vue?vue&type=style&index=0&id=5614b3ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5614b3ea",
  null
  
)

export default component.exports